const BillService = {
    getInvoiceData: function (billId, currency) {
        let url = '/admin/bills/' + billId + '/invoice-data';
        if (typeof currency !== 'undefined') url += '/' + currency;

        return $.ajax({
            async: true,
            url: url,
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getInvoiceDataFranchiser: function (billId, currency) {
        console.log(currency)
        let url = '/franchiser/bills/' + billId + '/invoice-data';
        if (typeof currency !== 'undefined') url += '/' + currency;

        return $.ajax({
            async: true,
            url: url,
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getInvoiceEmailHtml: function (billId) {
        return $.ajax({
            async: true,
            url: '/admin/bills/' + billId + '/invoice-email-html',
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    sendInvoiceEmail: function (billId) {
        return $.ajax({
            async: true,
            url: '/admin/bills/' + billId + '/invoice-email-send',
            method: 'POST',
            dataType: 'json',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getInvoiceAddPaymentHtml: function (billId) {
        return $.ajax({
            async: true,
            url: '/admin/bills/' + billId + '/invoice-add-payment-html',
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getInvoiceAddPaymentKarticarHtml: function (billId) {
        return $.ajax({
            async: true,
            url: '/admin/bills/' + billId + '/invoice-add-payment-karticar-html',
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    invoiceAddPayment: function (billId, formData) {
        return $.ajax({
            async: true,
            url: '/admin/bills/' + billId + '/invoice-add-payment',
            method: 'POST',
            data: formData,
            dataType: 'json',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    invoiceAddPaymentKarticar: function (billId) {
        return $.ajax({
            async: true,
            url: '/admin/bills/' + billId + '/invoice-add-payment-karticar',
            method: 'POST',
            dataType: 'json',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getInvoicePaymentItemsHtml: function (billId) {
        return $.ajax({
            async: true,
            url: '/admin/bills/' + billId + '/invoice-payment-items-html',
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getPrepaidRefundRequest: function (requestId) {
        return $.ajax({
            async: true,
            url: `/admin/bills/prepaid-refund-request/${requestId}`,
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getListPassesData: function (billId) {
        let url = '/admin/customers/' + billId + '/list/passes';
        return $.ajax({
            async: true,
            url: url,
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
}

export {BillService};